import { MIN_DISH_IMAGE_SIZE } from './eventFormConstants';

export const getImageDimensions = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Unable to read image'));
    };

    img.src = url;
  });

export const validateSquareImageMinDimensions = (width, height, minSize = MIN_DISH_IMAGE_SIZE) => {
  if (!width || !height) {
    return {
      valid: false,
      message: 'Unable to read image dimensions.',
    };
  }

  if (width !== height) {
    return {
      valid: false,
      message: 'Image must be square (equal width and height).',
    };
  }

  if (width < minSize || height < minSize) {
    return {
      valid: false,
      message: `Image must be at least ${minSize} × ${minSize}px (square).`,
    };
  }

  return { valid: true };
};
